import { motion } from "framer-motion";
import { CONTENT } from "@/content";
import { VerseCard } from "@/components/VerseCard";

const P = CONTENT.home.purpose;

export const SharePurpose = () => (
  <section className="purpose" data-testid="home-purpose">
    <div className="journey-head">
      <span className="pill">{P.label}</span>
      <h2 className="section-title" data-testid="purpose-title">{P.title}</h2>
      <p className="story-lines">{P.intro}</p>
    </div>
    <div className="purpose-grid">
      {P.parts.map((part, i) => (
        <motion.div
          key={part.label}
          className="purpose-col"
          initial={{ opacity: 0, x: i ? 40 : -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: [0.2, 0.7, 0.3, 1] }}
          data-testid={`purpose-part-${i + 1}`}
        >
          <span className={`pill ${i ? "light" : ""}`}>{part.label}</span>
          <h3 className="journey-title">{part.title}</h3>
          <p className="journey-text">{part.text}</p>
          <VerseCard items={[part.verse]} testId={`home-verse-card-${i + 1}`} />
        </motion.div>
      ))}
    </div>
    <p className="verse-note purpose-note" data-testid="home-verse-note">{P.note}</p>
  </section>
);
